import { OktaAuth } from '../idx';

// Export only a single object
export default OktaAuth;
